import { useState } from 'react';
import Modal from '../../../../../components/modals/Modal';
import MaterialIcons from '../../../../../components/ui/icons/MaterialIcons';
import AudioExplanation from '../../../../private/examenes/AudioExplanation';
import UploadFile from '../../../utils/UploadFile';
import EditCard from '../EditCard';
import type { Question as IQuestion } from '../../../../../data/interface-question';

interface QuestionProps {
	question: IQuestion;
	onUpdate: (
		questionID: string,
		key: string,
		newValue: any
	) => Promise<IQuestion | null>;
}

const VieEditAudioExplanation = ({ question, onUpdate }: QuestionProps) => {
	const [edit, setEdit] = useState(false);
	const [audio, setAudio] = useState<string>(question.audioFileName ?? '');

	const hasAudio =
		typeof question.audioFileName === 'string' &&
		question.audioFileName.trim() !== '';

	function handleUpdate() {
		onUpdate(question.id, 'audioFileName', audio)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	}

	const handleDelete = () => {
		onUpdate(question.id, 'audioFileName', undefined)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	return (
		<>
			<EditCard label='Explicación en Audio' onEdit={setEdit}>
				<div className='w-full flex flex-col items-center'>
					{hasAudio ? (
						<div className='w-full mt-4'>
							<div className='flex justify-between items-center'>
								<AudioExplanation audioFileName={question.audioFileName} />
								<button
									className='rounded bg-red-500 p-1 text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 ml-5 px-4 flex items-center gap-2'
									type='button'
									onClick={handleDelete}>
									<MaterialIcons
										icon='delete'
										classes='text-white text-lg'
										title='Eliminar'
									/>
									Eliminar
								</button>
							</div>
						</div>
					) : (
						<div className='w-full max-w-xl border-2 border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center justify-center bg-gray-50'>
							<MaterialIcons
								icon='audiotrack'
								classes='text-5xl text-gray-400 mb-4'
								title='Audio'
							/>
							<button
								type='button'
								className='text-brand-600 font-semibold hover:underline focus:outline-none mb-1'
								onClick={() => setEdit(true)}>
								{hasAudio
									? 'Editar archivo de audio'
									: 'Sube un archivo de audio'}
							</button>
							{/* <span className='text-gray-500 text-sm'>
							o arrastra y suelta (no obligatorio)
						</span> */}
							<span className='text-xs text-gray-400'>
								MP3, WAV, hasta 10MB
							</span>
						</div>
					)}
				</div>
			</EditCard>

			<Modal
				actionBtnText='Guardar Audio'
				handleAction={handleUpdate}
				headline='Gestionar Explicación en Audio'
				isOpen={edit}
				onClose={() => setEdit(false)}
				showCloseBtn={true}>
				<div className='mb-4'>
					<p className='text-sm text-gray-600'>
						Selecciona un archivo de audio para subir o reemplazar la
						explicación actual.
					</p>
				</div>
				<UploadFile
					onUpload={(path: string) => setAudio(path)}
					storageFolder='question-audio-files'
					fileName={audio}
					fileType='audio'
				/>
			</Modal>
		</>
	);
};
export default VieEditAudioExplanation;
